module.exports = __webpack_public_path__ + "static/media/Team 20 - Goal Diggers.79de3d3b.png";